































































































































import {
  Vue, Component, Prop, Watch, Mixins, Emit, PropSync,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  contains, pickBy, values, map, clone, any,
} from 'ramda'
import {
  update, field, collection, get, query, where, set, add, value,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import md5 from 'md5'
import firebase from 'firebase'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import TaskStore from '../../store/modules/tasks'
import { db } from '../../firebase/init'
import FindCustomer from '../customers/FindCustomer.vue'
import {
  ApiType, CommentType, CouponType, CouponTemplateType, CustomerType, BuildCouponType,
} from '../../types'

function getWeekday(w:string) {
  const s = String(w).substr(0, 3).toLowerCase()
  if (s === 'sun') return 0
  if (s === 'mon') return 1
  if (s === 'tue') return 2
  if (s === 'wed') return 3
  if (s === 'thu') return 4
  if (s === 'fri') return 5
  if (s === 'sat') return 6
  return -1
}

const uppercase = (x:string) => x.split(' ').map((s:string) => s.charAt(0).toUpperCase() + s.slice(1)).join(' ')

type TagType = {
  id:string,
  text:string,
}

interface LocalDataType {
  allLocations:boolean
  hasApi: boolean
  hasExpiration: boolean
  couponType:string
  calcDate: {
    weekday: string,
    days: number
  }
  validTemplateName: boolean
  newCouponId: string,
  numberOfCodes:number,
}

@Component({
  components: {
    FindCustomer,
  },
})
export default class AddCoupon extends Mixins(MainMixin) {
  @Prop({ default: false }) isTemplate!:boolean

  $refs:any

  selectedTemplateToRemove = ''

  blankData:LocalDataType = {
    allLocations: true,
    hasExpiration: false,
    hasApi: false,
    couponType: '',
    calcDate: {
      weekday: 'Any Day',
      days: 1,
    },
    validTemplateName: true,
    newCouponId: '',
    numberOfCodes: 5,
  }

  template:string = ''

  data = clone(this.blankData)

  @Watch('data', { deep: true, immediate: true })
  updatedData(data:LocalDataType) {
    this.coupon.singleLocation = data.allLocations ? '' : this.$store.getters.location
    if (!data.hasExpiration) {
      if (this.isTemplate) this.coupon.expiration = ''
      else this.coupon.expires = ''
    }
    if (data.hasExpiration && this.isTemplate) {
      this.coupon.expires = `${this.data.calcDate.days} ${this.data.calcDate.weekday}`.trim().toLowerCase()
      delete this.coupon.expiration
    }

    if (data.couponType === 'Single Known Customer' && this.isTemplate) {
      this.coupon.type = data.couponType
      this.data.numberOfCodes = 5
      this.data.newCouponId = ''
    }
    if (data.couponType === 'Single Use Codes' && this.isTemplate) {
      this.coupon.type = data.couponType
      this.data.newCouponId = ''
    }
    if (data.couponType === 'Multi Use Code' && this.isTemplate) {
      this.coupon.type = data.couponType
      this.data.numberOfCodes = 5
    }
    if (!this.isTemplate) {
      delete this.coupon.type
    }
    if (data.couponType !== 'Single Known Customer' || this.isTemplate) delete this.coupon.customer
    if (!data.hasApi) {
      this.coupon.creationTags = []
      this.coupon.redemptionTags = []
      this.coupon.creationApis = []
      this.coupon.redemptionApis = []
    }
  }

  reset() {
    this.coupon = clone(this.blankCoupon)
    console.log('resetting')
    if (this.isTemplate) {
      this.coupon.name = ''
      this.coupon.type = 'Single Known Customer'
    } else {
      this.coupon.customer = ''
    }
    this.template = ''
    this.data = clone(this.blankData)
    this.customer = null
    this.$refs.obs.reset()
  }

  @Watch('customer', { immediate: true })
  newCustomer(newCustomer:CustomerType|null) {
    if (newCustomer && newCustomer.id && !this.isTemplate) {
      this.coupon.customer = newCustomer.id
    } else this.coupon.customer = ''
  }

  @Watch('template')
  newTemplate(t:string) {
    console.log('template is: ', t)
    if (!t) this.reset()
    else this.updateTemplate(t)
  }

  get allTags() {
    const { tags } = this.$store.state.location.gData
    const getValue = (val:any) => ({ text: val.text, value: val.id })
    return map(getValue, values(tags))
  }

  isValid() {
    if (!this.data.validTemplateName) return false
    if (this.data.couponType === 'Single Known Customer' && !this.isTemplate && !this.coupon.customer) return false
    return true
  }

  loading = false

  checkLoading = false

  async removeTemplate() {
    this.loading = true
    const result = await db.collection('couponTemplates').doc(this.selectedTemplateToRemove).delete()
    console.log('result is: ', result)
    this.$toast.success(`Template '${this.selectedTemplateToRemove}' Deleted`)
    this.selectedTemplateToRemove = ''
    this.loading = false
  }

  titleDateFormat(d:any) {
    const x = dayjs(d).format('ddd, MMM D, YYYY')
    return `<strong>Expires: </strong>${x}`
  }

  async checkValidTemplateName() {
    this.checkLoading = true
    if (!this.coupon || !this.coupon.name) {
      this.checkLoading = false
      this.data.validTemplateName = true
      return true
    }
    const result = await db.collection('couponTemplates').doc(this.coupon.name.toLowerCase()).get()
    if (result.exists) {
      this.data.validTemplateName = false
      this.coupon.name = ''
    } else this.data.validTemplateName = true
    this.checkLoading = false
    return false
  }

  blankCoupon:BuildCouponType = {
    value: '',
    internalValue: 0,
    details: '',
    notes: '',
    expiration: '',
    singleLocation: '',
    creationApis: [],
    redemptionApis: [],
    creationTags: [],
    redemptionTags: [],
    categories: [], // couponCategory ID
  }

  coupon:BuildCouponType = clone(this.blankCoupon)

  customer:CustomerType|null = null


  get templates() {
    if (!this.$store.state.location.couponTemplates || this.$store.state.location.couponTemplates.length === 0) return []
    return this.$store.state.location.couponTemplates.map((template:CouponTemplateType) => ({ text: uppercase(template.id ? template.id : 'Error'), value: template.id }))
  }

  updateTemplate(templateData:string) {
    console.log('and here temp id is:', templateData)
    if (templateData !== '') {
      console.log('logging', this.$store.state.location.couponTemplates.find((c:any) => c.id === this.template))
      const template = clone(this.$store.state.location.couponTemplates.find((c:any) => c.id === this.template))
      // const template = clone(templateData)
      if (template.expires) {
        const expArray = template.expires.split(' ')
        console.log('exparray is: ', expArray)
        const days = parseInt(expArray[0], 10)
        if (!days) {
          template.expiration = ''
        } else {
          const wkday = getWeekday(expArray[1])
          if (wkday === -1) {
            template.expiration = dayjs().add(days, 'day').format('YYYY-MM-DD')
          } else {
            let addDays = wkday - dayjs().add(days, 'day').day()
            if (addDays < 0) addDays += 7
            console.log('addDays is: ', addDays)
            template.expiration = dayjs().add(days + addDays, 'day').format('YYYY-MM-DD')
            console.log('here exp: ', template.expiration)
          }
          this.data.hasExpiration = true
        }
      }
      this.data.allLocations = template.singleLocation === ''
      console.log('at bottom template is: ', template)
      if ((template.redemptionApis && template.redemptionApis.length > 0)
        || (template.redemptionTags && template.redemptionTags.length > 0)
        || (template.creationTags && template.creationTags.length > 0)
        || (template.creationApis && template.creationApis.length > 0)) {
        console.log('made it in here 2323')
        this.data.hasApi = true
      } else this.data.hasApi = false
      console.log('setting coupon type to : ', template.type)
      console.log('here template is: ', template)
      this.data.couponType = template.type
      delete template.type
      delete template.expires
      this.coupon = clone(template)
    } else this.reset()
  }

  get couponCategories() {
    return this.$store.state.location.gData.couponCategories || []
  }

  // setApis() {
  //   if (this.creationApi) {
  //     this.coupon.creationApis = [{ type: 'infusionsoft', value: this.creationApi }]
  //   } else this.coupon.creationApis = []
  //   if (this.redemptionApi) {
  //     this.coupon.redemptionApis = [{ type: 'infusionsoft', value: this.redemptionApi }]
  //   } else this.coupon.redemptionApis = []
  // }

  created() {
    this.coupon = clone(this.blankCoupon)
    if (this.isTemplate) {
      this.coupon.name = ''
      this.coupon.type = 'Single Known Customer'
    } else {
      this.coupon.customer = ''
    }
    this.data = clone(this.blankData)
  }
}

